unit Unit3;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Grids, WEBLib.DBCtrls,
  WEBLib.Controls, WEBLib.ExtCtrls, WEBLib.CDS, Data.DB, WEBLib.DB,
  Vcl.Graphics, WEBLib.Buttons, Math, Vcl.Imaging.pngimage, Vcl.Imaging.jpeg;

type
  TForm3 = class(TForm)
    WebLabel26: TLabel;
    WebLabel7: TLabel;
    WebLabel13: TLabel;
    WebLabel14: TLabel;
    WebLabel16: TLabel;
    WebLabel21: TLabel;
    WebComboBox4: TComboBox;
    WebComboBox3: TComboBox;
    WebComboBox2: TComboBox;
    WebComboBox1: TComboBox;
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    Zakupy: TImageControl;
    WebCheckBox1: TCheckBox;
    WebCheckBox2: TCheckBox;
    WebCheckBox3: TCheckBox;
    WebCheckBox5: TCheckBox;
    WebEdit6: TEdit;
    WebEdit7: TEdit;
    WebEdit12: TEdit;
    WebEdit13: TEdit;
    WebLabel3: TLabel;
    Opis: TImageControl;
    WebLabel4: TLabel;
    WebLabel6: TLabel;
    procedure WebComboBox1Click(Sender: TObject);
    procedure WebComboBox2Click(Sender: TObject);
    procedure WebComboBox3Click(Sender: TObject);
    procedure WebComboBox4Click(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  Form3: TForm3;

implementation

{$R *.dfm}

uses uFrmMain;

procedure TForm3.WebComboBox1Click(Sender: TObject);
var   ILO, ILO_P        : Real;
      PO, PO_P, TAK     : Integer;
begin
TAK:=0;
PO_P:=WebComboBox1.ItemIndex;
ILO_P:=StrtoFloat(WebEdit6.Text);
ILO:=0;
RAZ:=StrtoFloat(FrmMain.WebEdit5.Text);
ZAK:=StrtoFloat(FrmMain.WebEdit4.Text);
PO:=WebComboBox1.ItemIndex;
case PO of
0: ILO:=1.27;
1: ILO:=0.64;
2: ILO:=0.32;
3: ILO:=0.24;
4: ILO:=0.08;
end;
ZAK:=ZAK+ILO;
RAZ:=RAZ+ILO;
if WebCheckBox1.Checked=true then RAZ:=RAZ-ILO_P;
if WebCheckBox1.Checked=true then ZAK:=ZAK-ILO_P;
FrmMain.WebEdit5.Text:=FloattoStr(RAZ);
FrmMain.WebEdit4.Text:=FloattoStr(ZAK);
WebEdit6.Text:=FloattoStr(ILO);
WebCheckBox1.Checked:=true;
WebComboBox1.Color:=clMoneyGreen;
if WebCheckBox1.Checked=true then TAK:=Tak+1;
if WebCheckBox2.Checked=true then TAK:=Tak+1;
if WebCheckBox3.Checked=true then TAK:=Tak+1;
if WebCheckBox5.Checked=true then TAK:=Tak+1;
if TAK=4 then  FrmMain.WebEdit14.Text:='1';
end;


procedure TForm3.WebComboBox2Click(Sender: TObject);
var   ILO, ILO_P        : Real;
      PO, PO_P, TAK     : Integer;
begin
TAK:=0;
PO_P:=WebComboBox2.ItemIndex;
ILO_P:=StrtoFloat(WebEdit7.Text);
ILO:=0;
RAZ:=StrtoFloat(FrmMain.WebEdit5.Text);
ZAK:=StrtoFloat(FrmMain.WebEdit4.Text);
PO:=WebComboBox2.ItemIndex;
case PO of
0: ILO:=3.16;
1: ILO:=1.58;
2: ILO:=0.79;
3: ILO:=0.59;
4: ILO:=0.2;
end;
ZAK:=ZAK+ILO;
RAZ:=RAZ+ILO;
if WebCheckBox2.Checked=true then RAZ:=RAZ-ILO_P;
if WebCheckBox2.Checked=true then ZAK:=ZAK-ILO_P;
FrmMain.WebEdit5.Text:=FloattoStr(RAZ);
FrmMain.WebEdit4.Text:=FloattoStr(ZAK);
WebEdit7.Text:=FloattoStr(ILO);
WebCheckBox2.Checked:=true;
WebComboBox2.Color:=clMoneyGreen;
if WebCheckBox1.Checked=true then TAK:=Tak+1;
if WebCheckBox2.Checked=true then TAK:=Tak+1;
if WebCheckBox3.Checked=true then TAK:=Tak+1;
if WebCheckBox5.Checked=true then TAK:=Tak+1;
if TAK=4 then  FrmMain.WebEdit14.Text:='1';
end;

procedure TForm3.WebComboBox3Click(Sender: TObject);
var   ILO, ILO_P        : Real;
      PO, PO_P, TAK     : Integer;
begin
TAK:=0;
PO_P:=WebComboBox3.ItemIndex;
ILO_P:=StrtoFloat(WebEdit12.Text);
ILO:=0;
RAZ:=StrtoFloat(FrmMain.WebEdit5.Text);
ZAK:=StrtoFloat(FrmMain.WebEdit4.Text);
PO:=WebComboBox3.ItemIndex;
case PO of
0: ILO:=2.4;
1: ILO:=1.2;
2: ILO:=0.6;
3: ILO:=0.45;
4: ILO:=0.15;
end;
ZAK:=ZAK+ILO;
RAZ:=RAZ+ILO;
if WebCheckBox3.Checked=true then RAZ:=RAZ-ILO_P;
if WebCheckBox3.Checked=true then ZAK:=ZAK-ILO_P;
FrmMain.WebEdit5.Text:=FloattoStr(RAZ);
FrmMain.WebEdit4.Text:=FloattoStr(ZAK);
WebEdit12.Text:=FloattoStr(ILO);
WebCheckBox3.Checked:=true;
WebComboBox3.Color:=clMoneyGreen;
if WebCheckBox1.Checked=true then TAK:=Tak+1;
if WebCheckBox2.Checked=true then TAK:=Tak+1;
if WebCheckBox3.Checked=true then TAK:=Tak+1;
if WebCheckBox5.Checked=true then TAK:=Tak+1;
if TAK=4 then  FrmMain.WebEdit14.Text:='1';
end;

procedure TForm3.WebComboBox4Click(Sender: TObject);
var   ILO, ILO_P        : Real;
      PO, PO_P, TAK     : Integer;
begin
TAK:=0;
PO_P:=WebComboBox4.ItemIndex;
ILO_P:=StrtoFloat(WebEdit13.Text);
ILO:=0;
RAZ:=StrtoFloat(FrmMain.WebEdit5.Text);
ZAK:=StrtoFloat(FrmMain.WebEdit4.Text);
PO:=WebComboBox4.ItemIndex;
case PO of
0: ILO:=1.2;
1: ILO:=0.6;
2: ILO:=0.3;
3: ILO:=0.23;
4: ILO:=0.08;
end;
ZAK:=ZAK+ILO;
RAZ:=RAZ+ILO;
if WebCheckBox5.Checked=true then RAZ:=RAZ-ILO_P;
if WebCheckBox5.Checked=true then ZAK:=ZAK-ILO_P;
FrmMain.WebEdit5.Text:=FloattoStr(RAZ);
FrmMain.WebEdit4.Text:=FloattoStr(ZAK);
WebEdit13.Text:=FloattoStr(ILO);
WebCheckBox5.Checked:=true;
WebComboBox4.Color:=clMoneyGreen;
if WebCheckBox1.Checked=true then TAK:=Tak+1;
if WebCheckBox2.Checked=true then TAK:=Tak+1;
if WebCheckBox3.Checked=true then TAK:=Tak+1;
if WebCheckBox5.Checked=true then TAK:=Tak+1;
if TAK=4 then  FrmMain.WebEdit14.Text:='1';
end;

procedure TForm3.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebLabel26 := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebLabel13 := TLabel.Create(Self);
  WebLabel14 := TLabel.Create(Self);
  WebLabel16 := TLabel.Create(Self);
  WebLabel21 := TLabel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  Zakupy := TImageControl.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  Opis := TImageControl.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebCheckBox5 := TCheckBox.Create(Self);
  WebCheckBox3 := TCheckBox.Create(Self);
  WebCheckBox2 := TCheckBox.Create(Self);
  WebCheckBox1 := TCheckBox.Create(Self);
  WebComboBox4 := TComboBox.Create(Self);
  WebComboBox3 := TComboBox.Create(Self);
  WebComboBox2 := TComboBox.Create(Self);
  WebComboBox1 := TComboBox.Create(Self);
  WebEdit6 := TEdit.Create(Self);
  WebEdit7 := TEdit.Create(Self);
  WebEdit12 := TEdit.Create(Self);
  WebEdit13 := TEdit.Create(Self);

  WebLabel26.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebLabel13.BeforeLoadDFMValues;
  WebLabel14.BeforeLoadDFMValues;
  WebLabel16.BeforeLoadDFMValues;
  WebLabel21.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  Zakupy.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  Opis.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebCheckBox5.BeforeLoadDFMValues;
  WebCheckBox3.BeforeLoadDFMValues;
  WebCheckBox2.BeforeLoadDFMValues;
  WebCheckBox1.BeforeLoadDFMValues;
  WebComboBox4.BeforeLoadDFMValues;
  WebComboBox3.BeforeLoadDFMValues;
  WebComboBox2.BeforeLoadDFMValues;
  WebComboBox1.BeforeLoadDFMValues;
  WebEdit6.BeforeLoadDFMValues;
  WebEdit7.BeforeLoadDFMValues;
  WebEdit12.BeforeLoadDFMValues;
  WebEdit13.BeforeLoadDFMValues;
  try
    Name := 'Form3';
    Width := 725;
    Height := 461;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    WebLabel26.SetParentComponent(Self);
    WebLabel26.Name := 'WebLabel26';
    WebLabel26.Left := 8;
    WebLabel26.Top := 59;
    WebLabel26.Width := 54;
    WebLabel26.Height := 18;
    WebLabel26.Caption := 'Zakupy';
    WebLabel26.Font.Charset := DEFAULT_CHARSET;
    WebLabel26.Font.Color := clMenuHighlight;
    WebLabel26.Font.Height := -15;
    WebLabel26.Font.Name := 'Tahoma';
    WebLabel26.Font.Style := [fsBold];
    WebLabel26.HeightPercent := 100.000000000000000000;
    WebLabel26.ParentFont := False;
    WebLabel26.WidthPercent := 100.000000000000000000;
    WebLabel7.SetParentComponent(Self);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 8;
    WebLabel7.Top := 438;
    WebLabel7.Width := 211;
    WebLabel7.Height := 13;
    WebLabel7.Caption := 'Kalkulator fotowoltaiczny - Pro-Sun (c) 2022';
    WebLabel7.Color := clYellow;
    WebLabel7.HeightPercent := 100.000000000000000000;
    WebLabel7.Transparent := False;
    WebLabel7.WidthPercent := 100.000000000000000000;
    WebLabel13.SetParentComponent(Self);
    WebLabel13.Name := 'WebLabel13';
    WebLabel13.Left := 9;
    WebLabel13.Top := 88;
    WebLabel13.Width := 225;
    WebLabel13.Height := 13;
    WebLabel13.Caption := 'Ile wydajesz miesi'#281'cznie na rekreacj'#281' i kultur'#281'?';
    WebLabel13.HeightPercent := 100.000000000000000000;
    WebLabel13.WidthPercent := 100.000000000000000000;
    WebLabel14.SetParentComponent(Self);
    WebLabel14.Name := 'WebLabel14';
    WebLabel14.Left := 9;
    WebLabel14.Top := 135;
    WebLabel14.Width := 229;
    WebLabel14.Height := 13;
    WebLabel14.Caption := 'Ile miesi'#281'cznie wydajesz na meble i sprz'#281't AGD?';
    WebLabel14.HeightPercent := 100.000000000000000000;
    WebLabel14.WidthPercent := 100.000000000000000000;
    WebLabel16.SetParentComponent(Self);
    WebLabel16.Name := 'WebLabel16';
    WebLabel16.Left := 9;
    WebLabel16.Top := 166;
    WebLabel16.Width := 310;
    WebLabel16.Height := 13;
    WebLabel16.Caption := 'Ile  wydajesz ka'#380'dego miesi'#261'ca na posi'#322'ki i noclegi poza miastem?';
    WebLabel16.HeightPercent := 100.000000000000000000;
    WebLabel16.WidthPercent := 100.000000000000000000;
    WebLabel21.SetParentComponent(Self);
    WebLabel21.Name := 'WebLabel21';
    WebLabel21.Left := 8;
    WebLabel21.Top := 209;
    WebLabel21.Width := 205;
    WebLabel21.Height := 13;
    WebLabel21.Caption := 'Ile miesi'#281'cznie wydajesz na ubrania i buty?';
    WebLabel21.HeightPercent := 100.000000000000000000;
    WebLabel21.WidthPercent := 100.000000000000000000;
    WebLabel1.SetParentComponent(Self);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 8;
    WebLabel1.Top := 103;
    WebLabel1.Width := 325;
    WebLabel1.Height := 13;
    WebLabel1.Caption := ' (zwierz'#281'ta, sport, czasopisma,, elektronika, rozrywka, hobby itp.)?';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(Self);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 9;
    WebLabel2.Top := 181;
    WebLabel2.Width := 276;
    WebLabel2.Height := 13;
    WebLabel2.Caption := '(jedzenie w restauracjach, sto'#322#243'wkach i dania na wynos))';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    Zakupy.SetParentComponent(Self);
    Zakupy.Name := 'Zakupy';
    Zakupy.Left := 392;
    Zakupy.Top := 264;
    Zakupy.Width := 296;
    Zakupy.Height := 170;
    Zakupy.HeightPercent := 100.000000000000000000;
    Zakupy.WidthPercent := 100.000000000000000000;
    Zakupy.ChildOrder := 20;
    Zakupy.Picture.LoadFromFile('Unit3.Zakupy.Picture.jpg');
    WebLabel3.SetParentComponent(Self);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 2;
    WebLabel3.Top := 317;
    WebLabel3.Width := 188;
    WebLabel3.Height := 13;
    WebLabel3.Caption := 'Prosz'#281' odpowiedzie'#263' na ka'#380'de pytanie.';
    WebLabel3.Font.Charset := DEFAULT_CHARSET;
    WebLabel3.Font.Color := clBlue;
    WebLabel3.Font.Height := -11;
    WebLabel3.Font.Name := 'Tahoma';
    WebLabel3.Font.Style := [];
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.ParentFont := False;
    WebLabel3.WidthPercent := 100.000000000000000000;
    Opis.SetParentComponent(Self);
    Opis.Name := 'Opis';
    Opis.Left := 103;
    Opis.Top := 336;
    Opis.Width := 137;
    Opis.Height := 57;
    Opis.HeightPercent := 100.000000000000000000;
    Opis.WidthPercent := 100.000000000000000000;
    Opis.ChildOrder := 3;
    Opis.Picture.LoadFromFile('Unit3.Opis.Picture.png');
    WebLabel4.SetParentComponent(Self);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 2;
    WebLabel4.Top := 398;
    WebLabel4.Width := 246;
    WebLabel4.Height := 13;
    WebLabel4.Caption := 'Zielone pod'#347'wietlenie oznacza udzielon'#261' odpowied'#378;
    WebLabel4.Font.Charset := DEFAULT_CHARSET;
    WebLabel4.Font.Color := clBlue;
    WebLabel4.Font.Height := -11;
    WebLabel4.Font.Name := 'Tahoma';
    WebLabel4.Font.Style := [];
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.ParentFont := False;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel6.SetParentComponent(Self);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 538;
    WebLabel6.Top := 439;
    WebLabel6.Width := 150;
    WebLabel6.Height := 16;
    WebLabel6.Caption := 'Kontakt: biuro@pro-sun.pl';
    WebLabel6.Font.Charset := DEFAULT_CHARSET;
    WebLabel6.Font.Color := clBlue;
    WebLabel6.Font.Height := -13;
    WebLabel6.Font.Name := 'Tahoma';
    WebLabel6.Font.Style := [];
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.ParentFont := False;
    WebLabel6.WidthPercent := 100.000000000000000000;
    WebCheckBox5.SetParentComponent(Self);
    WebCheckBox5.Name := 'WebCheckBox5';
    WebCheckBox5.Left := 356;
    WebCheckBox5.Top := 206;
    WebCheckBox5.Width := 113;
    WebCheckBox5.Height := 22;
    WebCheckBox5.ChildOrder := 21;
    WebCheckBox5.Color := clNone;
    WebCheckBox5.HeightPercent := 100.000000000000000000;
    WebCheckBox5.State := cbUnchecked;
    WebCheckBox5.Visible := False;
    WebCheckBox5.WidthPercent := 100.000000000000000000;
    WebCheckBox3.SetParentComponent(Self);
    WebCheckBox3.Name := 'WebCheckBox3';
    WebCheckBox3.Left := 356;
    WebCheckBox3.Top := 169;
    WebCheckBox3.Width := 113;
    WebCheckBox3.Height := 22;
    WebCheckBox3.ChildOrder := 21;
    WebCheckBox3.Color := clNone;
    WebCheckBox3.HeightPercent := 100.000000000000000000;
    WebCheckBox3.State := cbUnchecked;
    WebCheckBox3.Visible := False;
    WebCheckBox3.WidthPercent := 100.000000000000000000;
    WebCheckBox2.SetParentComponent(Self);
    WebCheckBox2.Name := 'WebCheckBox2';
    WebCheckBox2.Left := 357;
    WebCheckBox2.Top := 132;
    WebCheckBox2.Width := 113;
    WebCheckBox2.Height := 22;
    WebCheckBox2.ChildOrder := 21;
    WebCheckBox2.Color := clNone;
    WebCheckBox2.HeightPercent := 100.000000000000000000;
    WebCheckBox2.State := cbUnchecked;
    WebCheckBox2.Visible := False;
    WebCheckBox2.WidthPercent := 100.000000000000000000;
    WebCheckBox1.SetParentComponent(Self);
    WebCheckBox1.Name := 'WebCheckBox1';
    WebCheckBox1.Left := 356;
    WebCheckBox1.Top := 92;
    WebCheckBox1.Width := 113;
    WebCheckBox1.Height := 22;
    WebCheckBox1.ChildOrder := 21;
    WebCheckBox1.Color := clNone;
    WebCheckBox1.HeightPercent := 100.000000000000000000;
    WebCheckBox1.State := cbUnchecked;
    WebCheckBox1.Visible := False;
    WebCheckBox1.WidthPercent := 100.000000000000000000;
    WebComboBox4.SetParentComponent(Self);
    WebComboBox4.Name := 'WebComboBox4';
    WebComboBox4.Left := 373;
    WebComboBox4.Top := 206;
    WebComboBox4.Width := 315;
    WebComboBox4.Height := 21;
    WebComboBox4.HeightPercent := 100.000000000000000000;
    WebComboBox4.Text := 'Oko'#322'o 100 PLN miesi'#281'cznie';
    WebComboBox4.WidthPercent := 100.000000000000000000;
    SetEvent(WebComboBox4, Self, 'OnClick', 'WebComboBox4Click');
    WebComboBox4.ItemIndex := 3;
    WebComboBox4.Items.BeginUpdate;
    try
      WebComboBox4.Items.Clear;
      WebComboBox4.Items.Add('Ponad 600 PLN miesi'#281'cznie');
      WebComboBox4.Items.Add('Oko'#322'o 300 PLN miesi'#281'cznie');
      WebComboBox4.Items.Add('Oko'#322'o 150 PLN miesi'#281'cznie');
      WebComboBox4.Items.Add('Oko'#322'o 100 PLN miesi'#281'cznie');
      WebComboBox4.Items.Add('Mniej ni'#380' 50 PLN miesi'#281'cznie');
    finally
      WebComboBox4.Items.EndUpdate;
    end;
    WebComboBox3.SetParentComponent(Self);
    WebComboBox3.Name := 'WebComboBox3';
    WebComboBox3.Left := 373;
    WebComboBox3.Top := 169;
    WebComboBox3.Width := 315;
    WebComboBox3.Height := 21;
    WebComboBox3.HeightPercent := 100.000000000000000000;
    WebComboBox3.Text := 'Oko'#322'o 150 PLN miesi'#281'cznie';
    WebComboBox3.WidthPercent := 100.000000000000000000;
    SetEvent(WebComboBox3, Self, 'OnClick', 'WebComboBox3Click');
    WebComboBox3.ItemIndex := 3;
    WebComboBox3.Items.BeginUpdate;
    try
      WebComboBox3.Items.Clear;
      WebComboBox3.Items.Add('Ponad 700 PLN miesi'#281'cznie');
      WebComboBox3.Items.Add('Oko'#322'o 300 PLN miesi'#281'cznie');
      WebComboBox3.Items.Add('Oko'#322'o 200 PLN miesi'#281'cznie');
      WebComboBox3.Items.Add('Oko'#322'o 150 PLN miesi'#281'cznie');
      WebComboBox3.Items.Add('Mniej ni'#380' 50 PLN miesi'#281'cznie');
    finally
      WebComboBox3.Items.EndUpdate;
    end;
    WebComboBox2.SetParentComponent(Self);
    WebComboBox2.Name := 'WebComboBox2';
    WebComboBox2.Left := 373;
    WebComboBox2.Top := 132;
    WebComboBox2.Width := 315;
    WebComboBox2.Height := 21;
    WebComboBox2.HeightPercent := 100.000000000000000000;
    WebComboBox2.Text := 'Oko'#322'o 150 PLN miesi'#281'cznie';
    WebComboBox2.WidthPercent := 100.000000000000000000;
    SetEvent(WebComboBox2, Self, 'OnClick', 'WebComboBox2Click');
    WebComboBox2.ItemIndex := 3;
    WebComboBox2.Items.BeginUpdate;
    try
      WebComboBox2.Items.Clear;
      WebComboBox2.Items.Add('Ponad 1000 PLN miesi'#281'cznie');
      WebComboBox2.Items.Add('Oko'#322'o 500 PLN miesi'#281'cznie');
      WebComboBox2.Items.Add('Oko'#322'o 200 PLN miesi'#281'cznie');
      WebComboBox2.Items.Add('Oko'#322'o 150 PLN miesi'#281'cznie');
      WebComboBox2.Items.Add('Mniej ni'#380' 50 PLN miesi'#281'cznie');
    finally
      WebComboBox2.Items.EndUpdate;
    end;
    WebComboBox1.SetParentComponent(Self);
    WebComboBox1.Name := 'WebComboBox1';
    WebComboBox1.Left := 373;
    WebComboBox1.Top := 92;
    WebComboBox1.Width := 315;
    WebComboBox1.Height := 21;
    WebComboBox1.HeightPercent := 100.000000000000000000;
    WebComboBox1.Text := 'Oko'#322'o 200 PLN miesi'#281'cznie';
    WebComboBox1.WidthPercent := 100.000000000000000000;
    SetEvent(WebComboBox1, Self, 'OnClick', 'WebComboBox1Click');
    WebComboBox1.ItemIndex := 3;
    WebComboBox1.Items.BeginUpdate;
    try
      WebComboBox1.Items.Clear;
      WebComboBox1.Items.Add('Pnad 1000 PLN miesi'#281'cznie');
      WebComboBox1.Items.Add('Oko'#322'o 500 PLN  miesi'#281'cznie');
      WebComboBox1.Items.Add('Oko'#322'o 300 PLN miesi'#281'cznie');
      WebComboBox1.Items.Add('Oko'#322'o 200 PLN miesi'#281'cznie');
      WebComboBox1.Items.Add('Mniej ni'#380' 100 PLN miesi'#281'cznie');
    finally
      WebComboBox1.Items.EndUpdate;
    end;
    WebEdit6.SetParentComponent(Self);
    WebEdit6.Name := 'WebEdit6';
    WebEdit6.Left := 311;
    WebEdit6.Top := 92;
    WebEdit6.Width := 38;
    WebEdit6.Height := 22;
    WebEdit6.ChildOrder := 30;
    WebEdit6.HeightPercent := 100.000000000000000000;
    WebEdit6.Text := '0';
    WebEdit6.Visible := False;
    WebEdit6.WidthPercent := 100.000000000000000000;
    WebEdit7.SetParentComponent(Self);
    WebEdit7.Name := 'WebEdit7';
    WebEdit7.Left := 311;
    WebEdit7.Top := 132;
    WebEdit7.Width := 38;
    WebEdit7.Height := 22;
    WebEdit7.ChildOrder := 30;
    WebEdit7.HeightPercent := 100.000000000000000000;
    WebEdit7.Text := '0';
    WebEdit7.Visible := False;
    WebEdit7.WidthPercent := 100.000000000000000000;
    WebEdit12.SetParentComponent(Self);
    WebEdit12.Name := 'WebEdit12';
    WebEdit12.Left := 312;
    WebEdit12.Top := 169;
    WebEdit12.Width := 38;
    WebEdit12.Height := 22;
    WebEdit12.ChildOrder := 30;
    WebEdit12.HeightPercent := 100.000000000000000000;
    WebEdit12.Text := '0';
    WebEdit12.Visible := False;
    WebEdit12.WidthPercent := 100.000000000000000000;
    WebEdit13.SetParentComponent(Self);
    WebEdit13.Name := 'WebEdit13';
    WebEdit13.Left := 311;
    WebEdit13.Top := 206;
    WebEdit13.Width := 38;
    WebEdit13.Height := 22;
    WebEdit13.ChildOrder := 30;
    WebEdit13.HeightPercent := 100.000000000000000000;
    WebEdit13.Text := '0';
    WebEdit13.Visible := False;
    WebEdit13.WidthPercent := 100.000000000000000000;
  finally
    WebLabel26.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebLabel13.AfterLoadDFMValues;
    WebLabel14.AfterLoadDFMValues;
    WebLabel16.AfterLoadDFMValues;
    WebLabel21.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    Zakupy.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    Opis.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebCheckBox5.AfterLoadDFMValues;
    WebCheckBox3.AfterLoadDFMValues;
    WebCheckBox2.AfterLoadDFMValues;
    WebCheckBox1.AfterLoadDFMValues;
    WebComboBox4.AfterLoadDFMValues;
    WebComboBox3.AfterLoadDFMValues;
    WebComboBox2.AfterLoadDFMValues;
    WebComboBox1.AfterLoadDFMValues;
    WebEdit6.AfterLoadDFMValues;
    WebEdit7.AfterLoadDFMValues;
    WebEdit12.AfterLoadDFMValues;
    WebEdit13.AfterLoadDFMValues;
  end;
end;

end.
